var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVpc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "VPC"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(0 0.00683594)",
    fill: "white",
    fillOpacity: 0.01,
    style: {
      mixBlendMode: "multiply"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Datastore"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 12.0068C11.7761 12.0068 12 11.783 12 11.5068C12 11.2307 11.7761 11.0068 11.5 11.0068C11.2239 11.0068 11 11.2307 11 11.5068C11 11.783 11.2239 12.0068 11.5 12.0068Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 11.0068H4V12.0068H10V11.0068Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 5.00684C11.7761 5.00684 12 4.78298 12 4.50684C12 4.23069 11.7761 4.00684 11.5 4.00684C11.2239 4.00684 11 4.23069 11 4.50684C11 4.78298 11.2239 5.00684 11.5 5.00684Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 4.00684H4V5.00684H10V4.00684Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 7.00684C13.2652 7.00684 13.5196 6.90148 13.7071 6.71394C13.8946 6.52641 14 6.27205 14 6.00684V3.00684C14 2.74162 13.8946 2.48727 13.7071 2.29973C13.5196 2.11219 13.2652 2.00684 13 2.00684H3C2.73478 2.00684 2.48043 2.11219 2.29289 2.29973C2.10536 2.48727 2 2.74162 2 3.00684V6.00684C2 6.27205 2.10536 6.52641 2.29289 6.71394C2.48043 6.90148 2.73478 7.00684 3 7.00684H4V9.00684H3C2.73478 9.00684 2.48043 9.11219 2.29289 9.29973C2.10536 9.48727 2 9.74162 2 10.0068V13.0068C2 13.2721 2.10536 13.5264 2.29289 13.7139C2.48043 13.9015 2.73478 14.0068 3 14.0068H13C13.2652 14.0068 13.5196 13.9015 13.7071 13.7139C13.8946 13.5264 14 13.2721 14 13.0068V10.0068C14 9.74162 13.8946 9.48727 13.7071 9.29973C13.5196 9.11219 13.2652 9.00684 13 9.00684H12V7.00684H13ZM3 3.00684H13V6.00684H3V3.00684ZM13 13.0068H3V10.0068H13V13.0068ZM11 9.00684H5V7.00684H11V9.00684Z",
    fill: "#161616"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVpc);
export default __webpack_public_path__ + "static/media/vpc.61da2a52e707543d745fb3215167d088.svg";
export { ForwardRef as ReactComponent };